document.addEventListener('click', function(e) {
  const button = e.target.closest('.quantity.cart-update .minus');
  if (button) {
    const input = button.closest('.quantity').querySelector('.qty');
    if (input && parseInt(input.value) <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const cartUpdate = button.closest('.cart-update');
      const index = input.dataset.index;
      const item = button.closest('.product-cart-item');
      if (item) item.classList.add('thb-loading');

      const body = JSON.stringify({
        line: index,
        quantity: 0,
        sections: ['cart-drawer', 'cart-bubble'],
        sections_url: window.location.pathname
      });

      fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body
      })
      .then(res => res.json())
      .then(parsedState => {
        if (parsedState.sections) {
          const drawerEl = document.getElementById('Cart-Drawer');
          if (drawerEl && parsedState.sections['cart-drawer']) {
            const parsed = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
            const newInner = parsed.querySelector('#Cart-Drawer');
            if (newInner) {
              drawerEl.innerHTML = newInner.innerHTML;
            }
          }
        }
      });
    }
  }
}, true);
